<template>
  <v-container class="black--text px-0" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-card class="title-card cmpbk" elevation="2" tile>
      <v-card-title class="title-card-text-1 justify-center py-0"
        >RSONU</v-card-title
      >
      <v-card-title class="title-card-text-2 justify-center py-0"
        >(Regional Sex Offender Notification Unit)</v-card-title
      >
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    margin: 0 auto;
  }
  .title-card {
    width: 100%;
  }

  .title-card-text-1 {
    font-size: 2rem;
    font-weight: 400;
  }

  .title-card-text-2 {
    font-size: 1rem;
    font-weight: 400;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "titlecard",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
